module.exports = __webpack_public_path__ + "img/ARMERIA.266d4770.png";